import { render, staticRenderFns } from "./GestionSmaStorage.vue?vue&type=template&id=3b90b6be&"
import script from "./GestionSmaStorage.vue?vue&type=script&lang=js&"
export * from "./GestionSmaStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports